import React, { useState } from 'react'

const AddNewVc = ({ isOpen, onClose, ref, setShowAddNewVcPopup, setShowNotification, setNotificationMessage, addVcErrorMessage, setAddVcErrorMessage }) => {
    const [email, setEmail] = useState('')
    const [name, setName] = useState('')
    if (!isOpen) return null;

    const handleNewVC = () => {
        let isValid = true;
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const newError = {
            name: '',
            email: ''
        }
        if (!name?.trim()) {
            newError.name = 'Please fill name.';
            isValid = false;
        }
        if (!email?.trim()) {
            newError.email = 'Please fill email address.';
            isValid = false;
        }
        if (email?.length > 0) {
            if (!emailPattern?.test(email)) {
                newError.email = 'Please enter valid email.';
                isValid = false;
            }
        }
        setAddVcErrorMessage(newError);
        if (!isValid) return;
        setShowAddNewVcPopup(false);
        setShowNotification(true);
        setTimeout(() => {
            setShowNotification(false)
        }, 8000)
        setNotificationMessage(`Invitation sent to ${email}`)
    }
    return (
        <>
            <div className="popup-overlay angel-popup">
                <div className="popup-box" ref={ref}>
                    <div className='popup-top-content'>
                        <div className="popup-close" onClick={onClose}>
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13 1L1 13M1 1L13 13" stroke="#05171A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                        <div className='popup-content'>
                            <div className='popup-title'>Add a new VC</div>
                            <p className="description">
                                To add a new VC, just enter their email address below.
                            </p>
                            <p className="warning">
                                We’ll send them an invite that includes a unique coupon code, so they can start discovering top founders with a head start.
                            </p>
                        </div>
                        <div className={`input-group ${name ? 'filled' : ''} ${addVcErrorMessage?.name ? 'show-error update-input-group' : ''}`}>
                            <input type="text" id='name' className='' name='name' autoComplete="off" value={name} onChange={(e) => {
                                setName(e.target.value);
                                if (addVcErrorMessage.name) {
                                    setAddVcErrorMessage(prev => ({ ...prev, name: '' }));
                                }
                            }} />
                            <label htmlFor="name">Full name</label>
                        </div>
                        {addVcErrorMessage?.name && (
                            <p className="error-message update-input-error">{addVcErrorMessage?.name}</p>
                        )}
                        <div className={`input-group ${email ? 'filled' : ''} ${addVcErrorMessage?.email ? 'show-error update-input-group' : ''}`}>
                            <input type="email" id='email' className='' name='email' autoComplete="off" value={email} onChange={(e) => {
                                setEmail(e.target.value);
                                if (addVcErrorMessage.email) {
                                    setAddVcErrorMessage(prev => ({ ...prev, email: '' }));
                                }
                            }} />
                            <label htmlFor="email">VC email address</label>
                        </div>
                        {addVcErrorMessage?.email && (
                            <p className="error-message add-invester-error">{addVcErrorMessage?.email}</p>
                        )}
                        <div className="radio-group">
                            <label className="radio-option">
                                <input type="radio" name="offer" value="50-3" />
                                <span className="custom-radio"></span>
                                50% off for 3 months
                            </label>
                            <label className="radio-option">
                                <input type="radio" name="offer" value="50-12" />
                                <span className="custom-radio"></span>
                                50% off for one year
                            </label>
                            <label className="radio-option">
                                <input type="radio" name="offer" value="free-3" />
                                <span className="custom-radio"></span>
                                Free for 3 months
                            </label>
                            <label className="radio-option">
                                <input type="radio" name="offer" value="free-12" defaultChecked />
                                <span className="custom-radio"></span>
                                Free for one year
                            </label>
                        </div>

                    </div>
                    <div className="button-row">
                        <button className="cancel-btn" onClick={onClose}>Cancel</button>
                        <button className="suspend-btn add-vc-btn" onClick={() => {
                            handleNewVC();
                        }}>Send</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddNewVc